import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Register from './auth/Register';
import Login from './auth/Login';
import { AppBar } from '@mui/material';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import Profile from './Profile';
import Privacy from './Privacy';
import Blog from './Blog';
import BlogPost from './BlogPost';
import AGB from './AGB';
import Impressum from './Impressum';
import ReactGA from 'react-ga4';
import RouteChangeTracker from './RouteChangeTracker';
import PaymentPage from './auth/PaymentPage';
import Willkommen from './auth/Willkommen';
import Index from './LandingPage2';
import CookieBanner from './components/CookieBanner';
import AdminPage from './admin/AdminPage';
import { initializeConsentFeatures, hasConsent } from './utils/cookieConsent';
import './index.css'; // Assuming you have a global CSS file

function App() {

    

    useEffect(() => {
      // Initialize consent-based features
      initializeConsentFeatures();
      
      // Initialize Google Analytics only if analytics consent is given
      if (hasConsent('analytics')) {
        ReactGA.initialize('G-GWNWCD60X7');
      }
    }, []);

    
    return (
        <Router>
            <div >
                <AppBar position="static">
                </AppBar>
                <RouteChangeTracker />
                <Routes>
                    <Route path="/" element={<Index />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/payment" element={<PaymentPage />} />
                    <Route path="/willkommen" element={<Willkommen />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/agb" element={<AGB />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:postId" element={<BlogPost />}>
                    </Route>
                </Routes>
                <CookieBanner />
            </div>
        </Router>
    ); 
}

export default App;

// {window.location.pathname !== '/register' &&


/*

<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-GWNWCD60X7"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-GWNWCD60X7');
</script>

*/